import { useQuery, useMutation } from "@tanstack/react-query";
import { instance, instanceWithToken } from "../../axios.config";
import { useUserStore } from "../../store/useUserStore";
// import { useUserStore } from "../../store/useUserStore";

export const useProfile = () => {
  return useQuery({
    queryKey: "profile",
    queryFn: async () => {
      const { data } = await instance.get("profile");
      return data;
    },
  });
};

export const useUpdateProfile = () => {
  return useMutation({
    mutationFn: async (body) => {
      const { data } = await instanceWithToken.put("profile", body);
      return data;
    },
  });
};

export const useUpdateAvatar = () => {
  const setUser = useUserStore((state) => state.setUser);

  return useMutation({
    mutationFn: async (file) => {
      let bodyFormData = new FormData();
      bodyFormData.append("avatar", file);

      const { data } = await instanceWithToken.post(
        "profile/avatar/update",
        bodyFormData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return data;
    },
    onSuccess: (data) => {
      setUser({ avatar: data.data.avatar_path });
    },
  });
};
